import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import FullscreenController from "../../utils/class.fullscreen_manager";
import { makeAPI } from "../../services/api";
import EventLeaderboard from "./event_leaderboard";
import CountdownTimer from "../custom_hooks/timer";
import coin from '../../assets/img/icons/coin.avif';
import { getViteImage } from "../../utils/utils";
import TournamentRegistrationPopup from "./tournament_registration_popup";



export default function TournamentDetails() {
    const fullscreenRef = useRef(null);
    const startDelayTimerRef = useRef(null);
    const tapCountdownTimerRef = useRef([]);
    const startEnableTimerRef = useRef(null);
    const isGameVisibleRef = useRef(false);
    const hasTapUnlockedRef = useRef(false);
    const lastOrientationRef = useRef("portrait");
    const [IframeHeight, setIframeHeight] = useState(600);
    const hasRun = useRef(false);
    const { event_id, game_id } = useParams();
    const [tournament_list, setTournamentList] = useState();
    const [recent_participants_data, setRecentParticipants] = useState([]);
    const user = JSON.parse(localStorage.getItem('user'));
    const user_id = user?.user_id;
    const [GamesData, setGamesData] = useState();
    const [register_button_status, setRegisterBtnStatus] = useState(false);
    const [active_tab, setactive_tab] = useState("leaderboard");
    const [Leaderboard_data, setLeaderboard_data] = useState([]);
    const FontAwseomeICon = { "leaderboard": "fa-solid fa-trophy fa-lg", "how": "fa-solid fa-circle-question fa-lg", "rules": "ic icon-list", "scoring": "icon-speedometer" };
    const [player_name , setplayer_name] = useState(user?.name); 
    const [registration_popup, setregistration_popup] = useState(false);
    const [isStartingGame, setIsStartingGame] = useState(false);
    const [isGameVisible, setIsGameVisible] = useState(false);
    const [iframeSrc, setIframeSrc] = useState("");
    const [iframeSessionKey, setIframeSessionKey] = useState(0);
    const [showSlowStartText, setShowSlowStartText] = useState(false);
    const [showTapToPlayOverlay, setShowTapToPlayOverlay] = useState(false);
    const [tapCountdown, setTapCountdown] = useState(0);
    const [inputUnlocked, setInputUnlocked] = useState(false);
    const [isIOSClient, setIsIOSClient] = useState(false);
    const [isStartReady, setIsStartReady] = useState(true);
    const launchConfigRef = useRef(null);
    const profile_pic = user?.profile_pic || 0;
    
    
    const isLandscapeMode = () => {
        if (window.matchMedia) return window.matchMedia("(orientation: landscape)").matches;
        return window.innerWidth > window.innerHeight;
    };

    const isTapRequiredForInitialLoad = () => {
        const raw = GamesData?.tap_required;
        if (typeof raw === "boolean") return raw;
        if (typeof raw === "number") return raw === 1;
        if (typeof raw === "string") return raw.toLowerCase() === "true" || raw === "1";
        return true;
    };

    const scheduleStartEnable = () => {
        if (isGameVisibleRef.current) return;
        if (!isIOSClient || !isLandscapeMode()) {
            setIsStartReady(true);
            return;
        }
        setIsStartReady(false);
        if (startEnableTimerRef.current) clearTimeout(startEnableTimerRef.current);
        startEnableTimerRef.current = setTimeout(() => {
            setIsStartReady(true);
        }, 3000);
    };

    const startTapCountdown = () => {
        setShowTapToPlayOverlay(true);
        setTapCountdown(3);
        tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
        tapCountdownTimerRef.current = [
            setTimeout(() => setTapCountdown(2), 1000),
            setTimeout(() => setTapCountdown(1), 2000),
            setTimeout(() => setTapCountdown(0), 3000)
        ];
    };

    const recoverIOSInputFocus = () => {
        const iframe = document.getElementById("game_frame");
        if (!iframe) return;
        setTimeout(() => {
            try {
                iframe.style.pointerEvents = "none";
                void iframe.offsetHeight;
                iframe.style.pointerEvents = "auto";
                iframe.focus();
                iframe.contentWindow?.focus();
            } catch (_) {
                // no-op
            }
        }, 260);
    };

    useEffect(() => {
        isGameVisibleRef.current = isGameVisible;
    }, [isGameVisible]);

    useEffect(() => {
        lastOrientationRef.current = isLandscapeMode() ? "landscape" : "portrait";
    }, []);

    useEffect(() => {
        if (isGameVisible) return;
        scheduleStartEnable();
        const onPrestartOrientation = () => {
            if (!isGameVisibleRef.current) scheduleStartEnable();
        };
        window.addEventListener("orientationchange", onPrestartOrientation);
        window.addEventListener("resize", onPrestartOrientation);
        return () => {
            window.removeEventListener("orientationchange", onPrestartOrientation);
            window.removeEventListener("resize", onPrestartOrientation);
        };
    }, [isIOSClient, isGameVisible]);


    // Initialize FullscreenController once
    useEffect(() => {
        fullscreenRef.current = new FullscreenController();
        const FSC = fullscreenRef.current;
        const os = FSC.getOS();
        setIsIOSClient(os === "iOS" || os === "iOS Tablet");

        // Handle orientation change for iOS
        const handleOrientationChange = () => {
            const OS = FSC.getOS();
            if (OS === "iOS" || OS === "iOS Tablet") {
                FSC.onOrientationChange(GamesData?.orientation || "landscape");
                if (isGameVisibleRef.current) {
                    const required = GamesData?.orientation || "landscape";
                    const current = FSC.DeduceOrientation?.() || "portrait";
                    const isCorrectOrientation = required === current;
                    const prevOrientation = lastOrientationRef.current;
                    lastOrientationRef.current = current;
                    if (isCorrectOrientation) {
                        // iOS: after returning to landscape, force a fresh user tap unlock.
                        setTimeout(() => {
                            setInputUnlocked(false);
                            startTapCountdown();
                        }, prevOrientation === "portrait" ? 350 : 120);
                    } else {
                        setInputUnlocked(false);
                        setShowTapToPlayOverlay(false);
                        setTapCountdown(0);
                    }
                }
                if (!isGameVisibleRef.current) scheduleStartEnable();
            }
        };

        window.addEventListener("orientationchange", handleOrientationChange);
        window.addEventListener("resize", handleOrientationChange);
        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", handleOrientationChange);
        }

        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
            window.removeEventListener("resize", handleOrientationChange);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener("resize", handleOrientationChange);
            }
        };
    }, [GamesData?.orientation]);

    useEffect(() => {
        scheduleStartEnable();
    }, [isIOSClient]);

    // Fallback: if iOS is back in valid orientation and input is still locked, force tap overlay.
    useEffect(() => {
        if (!isIOSClient || !isGameVisible) return;
        const required = GamesData?.orientation || "landscape";
        const current = fullscreenRef.current?.DeduceOrientation?.() || "portrait";
        const isCorrectOrientation = required === current;
        if (!isCorrectOrientation) return;
        if (inputUnlocked) return;
        if (showTapToPlayOverlay) return;

        const timer = setTimeout(() => {
            setInputUnlocked(false);
            startTapCountdown();
        }, 500);

        return () => clearTimeout(timer);
    }, [isIOSClient, isGameVisible, inputUnlocked, showTapToPlayOverlay, GamesData?.orientation, iframeSessionKey]);

    // Handle fullscreen exit event
    useEffect(() => {
        const handleFullscreenChange = () => {
            if (!document.fullscreenElement && fullscreenRef.current) {
                handleGameExit(false);
            }
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // Calculate iframe height based on screen size
    useEffect(() => {
        const calculateIframeHeight = () => {
            const isMobile = window.innerWidth < 768;
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            const windowHeight = Math.max(viewportHeight, 400);
            const Getdevice_info = fullscreenRef.current?.getOS() || {};
            if (isMobile) {
                setIframeHeight(windowHeight);
            } else {
                if (Getdevice_info === "iOS" || Getdevice_info === "iOS Tablet" || Getdevice_info === "Android" || Getdevice_info === "Android Tablet") {
                    setIframeHeight(windowHeight);
                } else {
                    setIframeHeight(600);
                }
            }
        };

        calculateIframeHeight();
        window.addEventListener('resize', calculateIframeHeight);
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', calculateIframeHeight);
        }

        return () => {
            window.removeEventListener('resize', calculateIframeHeight);
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', calculateIframeHeight);
            }
        };
    }, []);

    // Fetch tournament and game data
    useEffect(() => {
        document.title = "Tournament Information - CGES.CLUB";

        if (hasRun.current) return;
        hasRun.current = true;
        const fetchAllData = async () => {
            try {
                await Promise.all([
                    get_tournament_list(event_id, game_id),
                    get_game_info(game_id),
                    LeaderBoardData(game_id, event_id)
                ]);
                setplayer_name(user?.name);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                //Gracefully completed
            }
        };

        fetchAllData();
    }, [event_id, game_id]);

    useEffect(() => {
        // Reset game frame when route/game changes so stale SDK session is not reused.
        setIsGameVisible(false);
        setIframeSrc("");
        setIframeSessionKey(prev => prev + 1);
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);
        setInputUnlocked(false);
        hasTapUnlockedRef.current = false;
        setIsStartingGame(false);
        setShowSlowStartText(false);
        launchConfigRef.current = null;
        scheduleStartEnable();
    }, [event_id, game_id]);

    useEffect(() => {
        return () => {
            if (startDelayTimerRef.current) {
                clearTimeout(startDelayTimerRef.current);
                startDelayTimerRef.current = null;
            }
            if (startEnableTimerRef.current) {
                clearTimeout(startEnableTimerRef.current);
                startEnableTimerRef.current = null;
            }
            tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
            tapCountdownTimerRef.current = [];
        };
    }, []);

    // iOS safety gate: block all early touches/clicks until tap-to-play unlocks input.
    useEffect(() => {
        if (!isIOSClient || !isGameVisible || inputUnlocked) return;

        const container = document.getElementById("iframe-div");
        if (!container) return;

        const blockEvent = (e) => {
            const target = e.target;
            if (target?.closest?.("[data-allow-input='1']")) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
        };

        const nonPassiveCapture = { capture: true, passive: false };
        const captureOnly = true;

        const touchEvents = ["touchstart", "touchmove", "touchend", "touchcancel"];
        const pointerEvents = ["pointerdown", "pointermove", "pointerup", "pointercancel", "click"];

        touchEvents.forEach((eventName) => container.addEventListener(eventName, blockEvent, nonPassiveCapture));
        pointerEvents.forEach((eventName) => container.addEventListener(eventName, blockEvent, captureOnly));

        return () => {
            touchEvents.forEach((eventName) => container.removeEventListener(eventName, blockEvent, nonPassiveCapture));
            pointerEvents.forEach((eventName) => container.removeEventListener(eventName, blockEvent, captureOnly));
        };
    }, [isIOSClient, isGameVisible, inputUnlocked, iframeSessionKey]);

    const handleGameExit = (forceExit = false) => {
        const os = fullscreenRef.current?.getOS();
        const isMobileOrTab =
            os === "iOS" ||
            os === "iOS Tablet" ||
            os === "Android" ||
            os === "Android Tablet";

        fullscreenRef.current?.ExitFullscreen({ forceExit });
        if (startDelayTimerRef.current) {
            clearTimeout(startDelayTimerRef.current);
            startDelayTimerRef.current = null;
        }
        tapCountdownTimerRef.current.forEach((timer) => clearTimeout(timer));
        tapCountdownTimerRef.current = [];
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);
        setInputUnlocked(false);
        hasTapUnlockedRef.current = false;
        setIsStartingGame(false);
        setShowSlowStartText(false);
        scheduleStartEnable();

        if (isMobileOrTab) {
            // Mobile/Tab: return to banner state
            setIsGameVisible(false);
            setIframeSrc("");
            setIframeSessionKey((k) => k + 1);
            launchConfigRef.current = null;
            return;
        }

        // Desktop: keep iframe/game as-is
        // no state reset here
    };


    // Run fullscreen init only after iframe is mounted in DOM.
    useEffect(() => {
        if (!isGameVisible || !iframeSrc) return;
        if (!fullscreenRef.current) return;
        if (!launchConfigRef.current) return;

        fullscreenRef.current.func_int(launchConfigRef.current);
    }, [isGameVisible, iframeSrc, iframeSessionKey]);

    const get_tournament_list = async (event_id, game_id) => {
        const responseData = await makeAPI("/api/tournament", "POST", false, { event_id, game_id, user_id });
        if (responseData.status === "S") {
            const tournamentData = Array.isArray(responseData.data) ? responseData.data : [];
            setTournamentList(tournamentData);
            setRecentParticipants(responseData.recent_participants || []);
            setRegisterBtnStatus(Boolean(tournamentData[0]?.is_registered));
        }
    };

    const get_game_info = async (game_id) => {
        try {
            let GameInfo = await makeAPI('/api/get_game_info', 'post', false, { game_id });
            if (GameInfo) {
                setGamesData(GameInfo);
            }
        } catch (error) {
            console.error(error);
        }
    };

    const LeaderBoardData = async (game_id, event_id) => {
        try {
            const leaderboard = await makeAPI('/api/leaderboard', 'post', false, { inputObj: { game_id, event_id }});
            if (leaderboard.data.length > 0) {
                setLeaderboard_data([]);
                setTimeout(() => setLeaderboard_data([...leaderboard.data]), 10);
            }
        } catch (error) {
            console.log("Failed to Fetch");
            console.error(error);
        }

    }

    const PlayGame = async () => {
        if(new Date() > new Date(tournament_list[0].end_time)){
            alert("Tournament has ended. You can view the leaderboard and winners.");
            return;
        }
        if (isStartingGame) return;
        if (!GamesData) return;
        if (isIOSClient && !isStartReady) return;
        setIsStartingGame(true);
        setShowSlowStartText(false);
        if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
        startDelayTimerRef.current = setTimeout(() => {
            setShowSlowStartText(true);
        }, 3000);
        try {
            const login_status = await CheckLoginStatus();
            if (!login_status) {
                if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
                setIsStartingGame(false);
                setShowSlowStartText(false);
                return;
            }
            const startedInternal = LoadIframe();
            if (!startedInternal) {
                if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
                setIsStartingGame(false);
                setShowSlowStartText(false);
                scheduleStartEnable();
            }
        } catch (_) {
            if (startDelayTimerRef.current) clearTimeout(startDelayTimerRef.current);
            setIsStartingGame(false);
            setShowSlowStartText(false);
            scheduleStartEnable();
        }
    };

    const LoadIframe = () => {
        // alert("runtime called")
        localStorage.setItem('temp_game_info', JSON.stringify({ game_id: game_id, event_id: event_id }));
        
        if (!fullscreenRef.current) return;

        const FSC = fullscreenRef.current;
        const GetOS = FSC.getOS();
        const orientation = GamesData?.orientation || "landscape";

        // check if External Game or Internal Game:
        if (GamesData?.hosting_type === "external") {
            if (GetOS === "Unknown") {
                window.open(GamesData?.game_urls?.desktop_url);
                return false;
            }
            if(GetOS === "iOS" || GetOS === "iOS Tablet"){
                window.open(GamesData?.game_urls?.ios_url);
                return false;
            }
            window.open(GamesData?.game_urls?.mobile_url);
            return false;
        }

        // Ensure Orientation and Game Orientation are same for iOS devices before loading iframe.
        if ((GetOS === "iOS" || GetOS === "iOS Tablet") && orientation !== FSC.DeduceOrientation()) {
            alert("Please rotate your device to " + orientation + " mode to play the game.");
            // console.log("LoadIframe - Orientation mismatch for iOS device");
            return false;
        }

        // console.log("LoadIframe - OS:", GetOS, "Orientation:", orientation);

        // Common setup for all platforms
        setIframeSrc(GamesData?.game_urls?.desktop_url + '?event_id=' + event_id + '&game_id=' + game_id + '&player_name=' + player_name);
        setIframeSessionKey(prev => prev + 1);
        setIsGameVisible(true);
        setInputUnlocked(false);
        setShowTapToPlayOverlay(false);
        setTapCountdown(0);

        // Defer fullscreen init until iframe is mounted.
        launchConfigRef.current = { GetOS, orientation };

        // Show bottom strip for desktop
        if (GetOS === "Unknown") {
            // bottom strip is controlled by state-driven render.
        }
        return true;
    };

    const handleTapToPlay = () => {
        if (tapCountdown > 0) return;
        setShowTapToPlayOverlay(false);
        setInputUnlocked(true);
        hasTapUnlockedRef.current = true;
        const iframe = document.getElementById("game_frame");
        iframe?.focus();
        iframe?.contentWindow?.focus();
        recoverIOSInputFocus();
    };

    const CheckLoginStatus = async () => {
        let status = false;
        // currently using Localstorage Data. later on using share context.
        const user_id_ = JSON.parse(localStorage.getItem('user'));
        if (user_id_?.user_id && register_button_status) {

            status = true;
        } else {
            if (user_id_?.user_id && register_button_status === false) {
                let init_stat = await InitRegisteration();
                status = init_stat;
            } else {
                // depends on game (Intenal set time out to play a game) else return false;
                console.log("SET THE TIME INTERVAL OF GAME TO PLAY AND STOP .")
                const OpenModal = () => {
                    if (window.UIkit && typeof window.UIkit.modal === "function") {
                        window.UIkit.modal("#modal-login", { container: false }).show();
                    }
                };
                OpenModal();
            }

        }
        return status;
    };

    async function InitRegisteration() {
        let user = JSON.parse(localStorage.getItem('user'));
        let status = false;
        let gamer_handle = {};
        if (GamesData?.hosting_type === "internal") {
            // alert("internal")
            gamer_handle = user?.user_id;
            status = true;
        } else {
            // check if already have a gamer_handle or show popup to get gamer handle.
            if (Number(game_id) === 1) {
                if (!user?.gamer_handle || !user?.gamer_handle?.chess) {
                    setregistration_popup(true);
                    return false;
                }
                else {
                    setregistration_popup(false);
                    gamer_handle = user.gamer_handle.chess;
                }
            }
            if (Number(game_id) === 3) {
                if (!user?.gamer_handle || !user.gamer_handle?.clash_royal) {
                    setregistration_popup(true);
                    return false;
                }
                else {
                    setregistration_popup(false);
                    gamer_handle = user.gamer_handle.clash_royal;
                }
            }
        }
        setregistration_popup(false);
        // Call Registeration Function.
        let register = await RegisterTournament(gamer_handle);
        status = register;
        return status;
    }

    async function RegisterTournament(gamer_handle) {
        let register_status = false;
         const user = JSON.parse(localStorage.getItem('user'));
            let user_id =user?.user_id;
        try {
            let register = await makeAPI('/api/register_tournament', 'post', false, {user_id, event_id, gamer_handle, player_name, profile_pic, game_id });
            // console.log("API Response:", register);

            if (register?.status === "S") {
                setRegisterBtnStatus("REGISTERED");
                setregistration_popup(false);
                register_status = true;
            } else if(register?.status === "E"){
                alert("To play this tournament, you must use a different gamerhandle.")
                setregistration_popup(false);
            }
            else{
                setregistration_popup(false);
            }
            //  document.getElementById('button-register').disabled = false;
        } catch (error) {
            console.error("Error registering for tournament:", error);
        }
        return register_status;
    }

    const handleTimerEnd = async () => {
        setTournamentList(prev => {
            const updated = [...prev];
            updated[0].tournament_status = "completed";
            return updated;
        });

        // setTimerEnded(prev => !prev); // Toggle to trigger re-render
    };
    return (
        <>

            {registration_popup ? <TournamentRegistrationPopup onRegister={RegisterTournament} onClose={() => { setregistration_popup(false) }} game_id={Number(game_id)} game_name={GamesData?.game_name} event_id={event_id} /> : null}

            <div id="rotate-overlay" className="rotate-overlay">
                <div className="rotate-box">
                    <p><i class="fa-solid fa-rotate" style={{color:"var(--main-color-one)"}}></i> Rotate your device</p>
                    <small>This game works in {GamesData?.orientation || "landscape"} mode</small>
                </div>
            </div>


            <div className="uk-grid uk-grid-custom" data-uk-grid="">
                <div className="uk-width-3-4@l uk-width-3-5@m">
                    <div className="uk-grid uk-child-width-2-2@l uk-child-width-2-2@m uk-child-width-1-1@s">
                        <section className="b-post b-post-full b-post-single clearfix">
                            <div className="entry-media">
                                {!isGameVisible ? (
                                    <img className="img-fluid" src={getViteImage(GamesData?.banner_img_url)}
                                        id="img_frame" alt="Game Thumbnail" style={{ opacity: "0.5" }} />
                                ) : null}

                                {
                                    GamesData?.hosting_type === "internal" ? (
                                        <>
                                            <div id="iframe-div" style={{ display: isGameVisible ? 'block' : 'none' }}>
                                                <div
                                                    id='float_button'
                                                    data-allow-input='1'
                                                    style={{
                                                        top: "15px",
                                                        left: "0px",
                                                        position: "absolute",
                                                        display: "none",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        borderRadius: "0px 30px 30px 0px",
                                                        backgroundColor: "#ffffff",
                                                        height: "40px",
                                                        opacity: "0.8",
                                                        padding: "0 15px",
                                                        zIndex: "9999",
                                                        cursor: "pointer",
                                                        fontWeight: "bold",
                                                        fontSize: "14px",
                                                        color: "#000"
                                                    }}
                                                    onClick={() => handleGameExit(true)}
                                                >
                                                    Exit
                                                </div>

                                                {isGameVisible && iframeSrc ? (
                                                    <iframe
                                                        key={iframeSessionKey}
                                                        height={IframeHeight || 600}
                                                        width="100%"
                                                        id='game_frame'
                                                        src={iframeSrc}
                                                        name='iframe_a'
                                                        title={GamesData?.game_name}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: isIOSClient && isGameVisible ? '0px' : '10px 10px 0px 0px',
                                                            pointerEvents: isIOSClient && !inputUnlocked ? "none" : "auto"
                                                        }}
                                                        scrolling="no"
                                                        frameBorder="0"
                                                        tabIndex={0}
                                                        allowFullScreen
                                                        onLoad={() => {
                                                            if (startDelayTimerRef.current) {
                                                                clearTimeout(startDelayTimerRef.current);
                                                                startDelayTimerRef.current = null;
                                                            }
                                                            setIsStartingGame(false);
                                                            setShowSlowStartText(false);
                                                            if (!isIOSClient) {
                                                                setInputUnlocked(true);
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                return;
                                                            }
                                                            setInputUnlocked(false);
                                                            const orientation = GamesData?.orientation || "landscape";
                                                            const isCorrectOrientation = orientation === (fullscreenRef.current?.DeduceOrientation?.() || "portrait");
                                                            if (!isCorrectOrientation) {
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                return;
                                                            }
                                                            if (isTapRequiredForInitialLoad()) {
                                                                startTapCountdown();
                                                            } else {
                                                                setShowTapToPlayOverlay(false);
                                                                setTapCountdown(0);
                                                                setInputUnlocked(true);
                                                                recoverIOSInputFocus();
                                                            }
                                                        }}
                                                    />
                                                ) : null}

                                                {isGameVisible && isIOSClient && showTapToPlayOverlay ? (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            zIndex: 10010,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            background: "rgba(0,0,0,0.45)"
                                                        }}
                                                    >
                                                        <button
                                                            type="button"
                                                            data-allow-input='1'
                                                            className="btn text-white"
                                                            style={{
                                                                 backgroundColor: tapCountdown > 0 ? "transparent" : " #ff810e",
                                                                minWidth: "220px",
                                                                minHeight: "56px",
                                                                borderRadius: "12px",
                                                                fontSize: "20px",
                                                                fontWeight: 700
                                                            }}
                                                            onClick={handleTapToPlay}
                                                        >
                                                            {tapCountdown > 0 ? `Please wait ... ${tapCountdown}` : "Tap Screen To Play"}
                                                        </button>
                                                    </div>
                                                ) : null}
                                            </div>

                                            <div
                                                className="bottom-strip"
                                                style={{
                                                    backgroundColor: '#222',
                                                    padding: '5px 10px',
                                                    marginTop: '0px',
                                                    borderRadius: '0px 0px 10px 10px',
                                                    display: isGameVisible && !isIOSClient ? "block" : "none"
                                                }}
                                            >
                                                <div className="row align-items-center" style={{ padding: '0px 5px' }}>
                                                    <div className="col-12 col-sm-12">
                                                        <div className='row'>
                                                            <div className='d-flex justify-content-between'>
                                                                <div className="logo-aligned">
                                                                    {/* <img src="../images/cg_logo_white.png" width="30" alt="Logo" /> */}
                                                                    {/* <span className='game_name_footer'>{GamesData?.game_name.toUpperCase()}</span> */}
                                                                </div>
                                                                <div>
                                                                    <div
                                                                        style={{ textAlign: 'right' }}
                                                                        onClick={() => fullscreenRef.current?.EnterFullscreen('landscape')}
                                                                    >
                                                                        <span
                                                                            title='Fullscreen'
                                                                            className="icon fa fa-2x fa-expand"
                                                                            style={{
                                                                                fontSize: "15px",
                                                                                color: "#fff",
                                                                                fontWeight: "bolder",
                                                                                cursor: 'pointer'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : null
                                }

                                <button className="fl-gp-button" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-40%, -40%)", color: "#fff", backgroundColor: "var(--main-color-one)", padding: "15px 22px", border: "none", textAlign: "center", borderRadius: "33px", display: isGameVisible && !isStartingGame ? "none" : "inline-flex", alignItems: "center", gap: "8px", opacity: isStartingGame ? 0.85 : 1, cursor: isStartingGame ? "not-allowed" : "pointer" }}
                                    id="start-btn"
                                    disabled={isStartingGame || (isIOSClient && !isStartReady)}
                                    onClick={() => { PlayGame() }}
                                >
                                    {isStartingGame ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            {showSlowStartText ? "Loading build... please wait" : "Starting game..."}
                                        </>
                                    ) : (isIOSClient && !isStartReady) ? (
                                        <>
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            Preparing game...
                                        </>
                                    ) : "Start Game"}
                                </button>
                            </div>

                            <div className="entry-main ">
                                {tournament_list ? (
                                    tournament_list.map((data, index) =>
                                        <React.Fragment key={index}>
                                            <hr />
                                            <div className="row tour-detail-pad-left" >
                                                <div className="col-md-6 col-12 tour-left-line" >
                                                    <span className="" style={{ fontSize: "x-large", fontWeight: "600" }}>{data.event_title}</span> <br />
                                                    <span style={{ color: "var(--main-color-one)", fontSize: "smaller" }}>{data.tournament_date?.start.toUpperCase()} to {data.tournament_date?.end.toUpperCase()}</span>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row tour-detail-pad-left" >
                                                <div className="col-md-3 col-6">
                                                    <span className="tour-detail-small-text">Prize Pool</span> <br /><span className="tour-detail-small-text"><img src={coin} width="15" alt="CGES coin" /> {data.prize_pool}</span>
                                                </div>
                                                <div className="col-md-3 col-6">
                                                    <span className="tour-detail-small-text">DURATION</span> <br />
                                                    <span className="tour-detail-small-text"><i className="fa fa-clock me-2" aria-hidden="true" style={{ color: "var(--main-color-one)" }}></i>{data.tournament_duration || "7days"}</span> <br />
                                                </div>
                                                <div className="col-md-3 col-6">
                                                    {data.tournament_status === 'live' ? (
                                                        <>
                                                            <span className="tour-detail-small-text">ENDS IN:</span>
                                                            <br />
                                                            <span className="tour-detail-small-text">
                                                                <i className="fa fa-clock" style={{ color: "var(--main-color-one)" }}></i>&nbsp;
                                                                <CountdownTimer remainingSeconds={data.end_time} onTimerEnd={handleTimerEnd} />
                                                            </span>
                                                        </>
                                                    ) : data.tournament_status === 'upcoming' ? (
                                                        <>
                                                            <span className="tour-detail-small-text">STARTS IN:</span>
                                                            <br />
                                                            <span className="tour-detail-small-text">
                                                                <i className="fa fa-clock"></i>&nbsp;
                                                                <CountdownTimer remainingSeconds={data.start_time} onTimerEnd={handleTimerEnd} />
                                                            </span>
                                                        </>
                                                    ) : data.tournament_status === 'completed' || (new Date(data?.end_time) < new Date()) ? (
                                                        <>
                                                            <span className="tour-detail-small-text">COMPLETED</span>
                                                        </>
                                                    ) : (
                                                        <b>{data.tournament_status.toUpperCase()}</b>
                                                    )}
                                                </div>
                                                <div className="col-md-3 col-6">
                                                    <span className="tour-detail-small-text">PARTICIPANTS:</span><br />
                                                    <span className="tour-detail-small-text"><i className="fa fa-account" aria-hidden="true"></i>&nbsp;N/A</span>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="fl-subnav">
                                                <ul className="uk-subnav uk-subnav-pill" uk-margin="" style={{ background: "transparent", margin: "0px 0px 0px 0px" }} >
                                                    {GamesData?.description ? Object.entries(GamesData.description).map(([key, value]) => {
                                                        return (
                                                            <li key={key}
                                                                className={`uk ${key === active_tab ? 'uk-active uk-first-column' : ""}`}
                                                                onClick={() => setactive_tab(key)}>
                                                                <a href="#" style={{ color: "#fff", backgroundColor: "transparent" }}><i className={FontAwseomeICon[key] || ""}>

                                                                </i>{key.charAt(0).toUpperCase() + key.slice(1)}</a>
                                                            </li>
                                                        )
                                                    }) : null}
                                                </ul>
                                            </div>
                                            <div className="entry-content" id={active_tab === "leaderboard" ? "lb-size-change" : ""}>
                                                {active_tab === "leaderboard" ? (
                                                    tournament_list ? <EventLeaderboard data={tournament_list} /> : null
                                                ) : GamesData?.description?.[active_tab] ? (
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: GamesData.description[active_tab].replace(/classname\s*=/gi, "class="),
                                                        }}
                                                    />
                                                ) : null}
                                            </div>
                                        </React.Fragment>
                                    )
                                ) : null}
                            </div>
                        </section>
                    </div>
                </div>

                {/* <div className="uk-width-1-5@l uk-width-2-5@m">
                    <aside className="l-sidebar">
                        
                    </aside>
                </div> */}
                <div className="uk-width-1-5@l uk-width-2-5@m">

                    <aside className="l-sidebar">

                        <section className="widget section-sidebar bg-light d-none d-lg-block">
                            <h3 className="widget-title bg-dark"><i className="ic icon-list"></i>Top 10 Leaderboard  &nbsp;&nbsp;
                                <span style={{ cursor: "pointer", color: "var(--main-color-one)" }} onClick={() => {
                                    // alert("refresh alert");
                                }}>
                                    {/* <i className="fa-solid fa-retweet">
                                        <span className="animation-ripple-delay1"></span>
                                    </i> */}
                                    </span>
                            </h3>

                            <table className="table table-dark">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Player Name</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Leaderboard_data?.length > 0 ? (
                                        Leaderboard_data.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.rank ?? index + 1}</td>
                                                <td>{item.player_name}</td>
                                                <td><img src={coin} width={15} height={15} />&nbsp;{item.points}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3" style={{ textAlign: "center" }}>
                                                No leaderboard data
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </section>

                        <section className="widget section-sidebar bg-light">
                            <h3 className="widget-title bg-dark"><i className="ic icon-calendar"></i>recent participants</h3>
                            <div className="widget-content">
                                <div className="widget-inner p-0">

                                    {!recent_participants_data || recent_participants_data.length === 0 ? (
                                        <h5 className="text-center text-light p-4">No Recent Participants</h5>
                                    ) : (
                                        <table className="table table-dark align-middle mb-0">
                                            <tbody>
                                                {recent_participants_data.map((item, index) => (
                                                    <tr key={item.user_id || index}>

                                                        {/* Image Column */}
                                                        <td style={{ width: "70px", borderRight: "1px solid #4d5154" }}>
                                                            <img
                                                                src={getViteImage(`profile_avatar/${item.profile_pic}.avif`)}
                                                                alt="profile"
                                                                className="img-fluid rounded-circle"
                                                                style={{ width: "45px", height: "45px", objectFit: "cover" }}
                                                            />
                                                        </td>

                                                        {/* Name Column */}
                                                        <td>
                                                            <h6 className="mb-0">{item.player_name}</h6>
                                                        </td>

                                                        {/* Optional Column */}
                                                        <td className="text-muted small"></td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}

                                </div>
                            </div>
                        </section>

                    </aside>
                </div>
            </div>

            <style>{`
                .tour-detail-pad-left {
                    padding-left: 20px !important;
                }

                .tour-detail-left-line {
                    border-left: 5px solid #ff810e !important;
                }

                .tour-detail-small-text {
                    font-size: 13px !important;
                    opacity: 0.7 !important;
                }
                #iframe-div {
                    display: none;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    background: #000;
                    position: relative;
                }

                #game_frame {
                    width: 100%;
                    border: none;
                }

                #img_frame {
                    width: 100%;
                    height: auto;
                }

                .float_button_visibility {
                    display: flex !important;
                    visibility: visible !important;
                    z-index: 9999 !important;
                    pointer-events: auto !important;
                    opacity: 0.8 !important;
                }

                .fullscreen_manager {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 100vw !important;
                    height: 100vh !important;
                    height: 100dvh !important;
                    z-index: 9999 !important;
                    background: #000 !important;
                    overflow: hidden !important;
                }

                @media (max-width: 768px) {
                    #iframe-div {
                        border-radius: 0;
                    }
                    
                    #game_frame {
                        border-radius: 0;
                    }
                }
                .rotate-overlay {
    position: fixed;
    inset: 0;
    background: #000 !important;
    display: none;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 10000;
}

.rotate-overlay.show {
    display: flex;
}

.rotate-box {
    color: #fff;
    font-size: 20px;
}

            `}</style>
        </>
    );
}
